import '../styles/theme.scss';

import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import convertDataAttributesToObject from './lib/convertDataAttributesToObejct';
import { fetchSVG, loadIcons } from './lib/SVGSprite';
import moduleDefinition, { ModuleDefinition } from './modules/definition';
import { definition as widgetDefinition, Widget } from './widgets';

/**
 * Async Modules: Modules are defined in ./modules/definitions.ts
 */
const bootstrap = {
  init() {
    this.asyncSVG.init();
    this.asyncModules.init(moduleDefinition);
    this.asyncWidgets.init(widgetDefinition);
  },
  asyncModules: {
    init(modules: ModuleDefinition[]) {
      (modules ?? []).forEach(({ selector, moduleName, defaultArgs }) => {
        (document.querySelectorAll<HTMLElement>(selector) ?? []).forEach((el) => {
          const formattedArgs = convertDataAttributesToObject(el.dataset ?? {});
          const args = { ...defaultArgs, ...formattedArgs };

          return this.load(el, moduleName, args);
        });
      });
    },
    load: (el: HTMLElement, moduleName: string, args: Record<string, unknown>) => {
      try {
        return import(`./modules/${moduleName}`).then((mod) => {
          const Module = mod.default;
          return new Module(el, args);
        });
      } catch (error: unknown) {
        const err = error as Error;
        console.warn(err);
      }

      return false;
    },
  },
  asyncWidgets: {
    init: (widgets: ModuleDefinition[]) => {
      (widgets ?? []).forEach(({ selector, moduleName }) => {
        (document.querySelectorAll<HTMLElement>(selector) ?? []).forEach(el => new Widget(el, moduleName));
      });

      window.addEventListener('initWidget', (ev) => {
        if (ev.detail.element) {
          return new Widget(ev.detail.element, ev.detail.widget);
        }

        return false;
      });
    },
  },
  asyncSVG: {
    init() {
      fetchSVG('./wp-content/themes/class/dist/sprite.svg')
        .catch((error: Error) => console.warn(`[fetchSVG] ${error}`));
    },
  },
};

document.addEventListener('DOMContentLoaded', () => {
  bootstrap.init();
});

// SVG Sprite Loader
loadIcons();
